// @ts-nocheck
import { teal } from 'api';
import { updated } from 'store/slices/auth';
import { requestStarted, requestSucceeded, requestFailed } from 'store/slices/apiCalls';

export function initializeAuthentication() {
    return { type: 'AUTH_INIT' };
}

export function login() {
    return { type: 'AUTH_REQUEST_LOGIN' };
}

export function logout() {
    return { type: 'AUTH_REQUEST_LOGOUT' };
}

export function register() {
    return { type: 'AUTH_REQUEST_REGISTER' };
}

export function getUser() {
    return async (dispatch) => {
        dispatch(requestStarted({ key: 'auth.getUser' }));

        let user;
        try {
            user = await teal.getUser();
            dispatch(updated({ user }));
            dispatch(requestSucceeded({ key: 'auth.getUser' }));
            return user;
        } catch(error) {
            dispatch(requestFailed({ key: 'auth.getUser', error }));
            return error;
        }
    };
}
